export default "__VITE_ASSET__CkbQ03CK__"